export default __webpack_public_path__ + "static/media/edit.c91522f6.svg";